import _ from 'lodash';
import f from 'isomorphic-fetch';
import * as types from './actionTypes';

export const fetch = () => ({
    types: [ types.FETCH_REQUEST, types.FETCH_SUCCESS, types.FETCH_FAILURE ],
    apiCall: () => f('/config/config.json').then(res => res.json()),
    predicate: state => _.isEmpty(state.config)
});